// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { PrEndpointImpactSourceBucketSchema } from '../inputTypeSchemas/PrEndpointImpactSourceBucketSchema'

/////////////////////////////////////////
// PR ENDPOINT IMPACT SCHEMA
/////////////////////////////////////////

export const PrEndpointImpactSchema = z.object({
  sourceBuckets: PrEndpointImpactSourceBucketSchema.array(),
  endpointId: z.string().nullable(),
  signalsCreated: z.number().int(),
})

export type PrEndpointImpact = z.infer<typeof PrEndpointImpactSchema>

export default PrEndpointImpactSchema;
